import EntityTypeEnum from 'common/enums/entityTypeEnum'

export const rootEntitiesWithSections = [
  EntityTypeEnum.Body,
  EntityTypeEnum.WebsiteLayoutBody,
  EntityTypeEnum.WebsitePageBody,
  EntityTypeEnum.BlogPageBody,
  EntityTypeEnum.InlineBody,
  EntityTypeEnum.RemotePopupBody,
] as const
